import { STORAGE_TYPE } from "../constants"

const storageReducer = (state = {
   clientKey: '',
   returnUrl: ''
}, action) => {
   switch (action.type) {
      case STORAGE_TYPE.SET_CLIENT_KEY:
         return {
            ...state,
            clientKey: action.payload
         }
      case STORAGE_TYPE.SET_RETURN_URL:
         return {
            ...state,
            returnUrl: action.payload
         }
      default:
         return state
   }
}

export default storageReducer